import React from 'react'
import { ChatTemplateListContainer } from '@/components/containers/chat-template-list'
import { useTitle } from '@/hooks/use-title'
import SettingsIcon from '@material-ui/icons/Settings'

export const ChatTemplateListPage: React.FC = () => {
  useTitle('設定 / チャットテンプレート', <SettingsIcon />)
  return <ChatTemplateListContainer />
}
